<template>
  <d2-container>
    <template slot="header">
      <el-input
        @keyup.enter.native="getSearch(1)"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
        :clearable="true"
      ></el-input>
      <el-button @click="getSearch(1)" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="closeData"
    >
      <el-table-column align="center" label="销售码id">
        <template slot-scope="scope">
          <span class="rowId" @click="getRow(scope.row.id)">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="销售码">
        <template slot-scope="scope">
          <el-image    style="width: 100px; height: 100px" :preview-src-list="[scope.row.qrCodeUrl]" :key="scope.row.qrCodeUrl" :src="scope.row.qrCodeUrl">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="销售员">
        <template slot-scope="scope">
         <popover-user-info :id="scope.row.accountId"></popover-user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" label="扫码数量">
        <template slot-scope="scope">
          <span>{{ scope.row.scanCount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="核销数量">
        <template slot-scope="scope">
          <span>{{ scope.row.verificationCount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="viewOrder(scope.row.id)"
            v-permission:function="['certificateListDManger:btn_cont']"
            style="margin-top: 10px;"
          >查看订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { userCerts, getAttrBase, getBaseSet } from '@/api/demo/certificateList/index'
import { certList } from '@/api/demo/close/index'
import { getVeriOrderRecordList } from '@/api/demo/veriOrder'
import PopoverUserInfo from '@/components/users/popoverUserInfo.vue'
export default {
  name: 'certificateListDManger',
  components: { PopoverUserInfo },
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      baseList: [], // 基础属性集合
      listQuery: {
        accountId: '', // 用户id
        orderId: '', // 销售单id
        pageSize: 20
      },
      listStatus: [],
      listS: {
        currentPage: 1,
        pageSize: 20
      },
      closeData: [], // 数据
      total: null,
      centerDialogVisible: false, // 获取基础属性
      deduction: false, // 扣除基础属性
      val: null,
      form: {
        attrId: null, // 账户
        remark: '', // 增加属性成长值
        userCertId: null, // 用户亲密证书id
        value: 0 // 增加属性成长值
      },
      attribute: '',
      rules: {},
      certId: null
    }
  },
  watch: {
  },
  created () {

  },
  mounted () {
    this.listQuery.orderId = this.$route.query.id
    this.getSearch()
  },
  methods: {
    // 搜索条件
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getVeriOrderRecordList(that.listQuery).then(res => {
        that.listLoading = true
        that.closeData = res.records
        console.log(that.$data, that.$options.data())
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    // 获取基础属性
    editCont (id) {
      let that = this
      let data = { userCertId: id }
      that.certId = id
      getAttrBase(data).then(res => {
        that.listLoading = true
        that.baseList = res
        that.centerDialogVisible = true
        that.listLoading = false
      })
      // this.$router.push({
      //   path: "./certificateList/baseList",
      //   query: {
      //     id: id
      //   }
      // });
    },
    viewOrder (id) {
      this.$router.push('/demo/order?qrCodeId=' + id)
    },
    // 扣除基础属性
    delCont (id, name, val) {
      let that = this
      // if (this.certId == null) {
      //   let that = this;
      //   that.$router.push({
      //     path: "../../demo/certificateList"
      //   });
      //   return false;
      // }
      that.val = val
      that.attribute = name
      that.form.attrId = id
      that.form.userCertId = that.certId
      that.centerDialogVisible = false
      that.deduction = true
    },
    // 扣除
    getDetermine (id) {
      let that = this
      that
        .$confirm('此操作将永久扣除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          getBaseSet(that.form).then(() => {
            that.getSearch()
            that.$notify({
              title: '成功',
              message: '扣除成功',
              type: 'success',
              duration: 2000
            })
            let data = { userCertId: that.certId }
            getAttrBase(data).then(res => {
              that.listLoading = true
              that.baseList = res
              that.centerDialogVisible = true
              that.listLoading = false
            })
            that.deduction = false
            that.centerDialogVisible = true
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消扣除'
          })
          that.deduction = false
          that.centerDialogVisible = true
        })
    },
    // 跳转到影响力审核
    getRow (id) {
      let that = this
      that.$router.push({
        path: '../../demo/examineList',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.rowId {
  cursor: pointer;
  color: rgb(64, 158, 255);
}
</style>
